<template>
  <v-expansion-panels v-if="totalExhibitionItems">
    <v-expansion-panel>

      <v-expansion-panel-header>
        {{ $t('exhibitionItems.exhibitionItems') }}
      </v-expansion-panel-header>

      <v-expansion-panel-content>

        <v-data-table
          :headers="headers"
          :items="exhibitionItems"
          :options.sync="options"
          :items-per-page="-1"
          :server-items-length="totalExhibitionItems"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-btn color="primary" :to="`/exhibitions/${exhibitionId}/exhibition-items/new`" class="ma-4">
              {{ $t('exhibitionItems.list.newExhibitionItem') }}
            </v-btn>
          </template>

          <template v-slot:item.isHidden="{ item }">
            {{ $t(item.isHidden ? 'common.yes' : 'common.no') }}
          </template>

          <template v-slot:item.drag="{ item }">
            <v-icon draggable="true"
                    @dragstart='startDrag($event, item)'>
              mdi-drag
            </v-icon>
          </template>

          <template v-slot:item.open="{ item }">
            <v-btn icon small :to="`/exhibitions/${exhibitionId}/exhibition-items/${item.id}`" >
              <v-icon>
                mdi-eye
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              small
              class="mr-2"
              :to="`/exhibitions/${exhibitionId}/exhibition-items/${item.id}/update`">
              <v-icon
                small
                :to="`/exhibitions/${exhibitionId}/exhibition-items/${item.id}/update`"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-icon
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:item.createdAt="{ item }">
            <span>{{ new Date(item.createdAt).toLocaleString() }}</span>
          </template>

          <template v-slot:item.updatedAt="{ item }">
            <span>{{ new Date(item.updatedAt).toLocaleString() }}</span>
          </template>
        </v-data-table>

      </v-expansion-panel-content>

    </v-expansion-panel>
  </v-expansion-panels>

  <v-row v-else justify="center" align="center" class="max-height">
    {{ $t('exhibitionItems.list.noExhibitionItem') }}
    <v-btn plain color="primary" :to="`/exhibitions/${exhibitionId}/exhibition-items/new`">
      {{ $t('exhibitionItems.list.newExhibitionItem') }}
    </v-btn>
  </v-row>

</template>

<script>
/* eslint-disable no-console, no-param-reassign */
import i18n from '@/i18n';

export default {
  name: 'ExhibitionItemList',
  props: {
    exhibitionId: String,
    showDraggableColumn: Boolean,
    bus: Object,
  },
  data() {
    return {
      options: {},
    };
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  methods: {
    getDataFromApi() {
      const {
        page, itemsPerPage,
      } = this.options;
      this.$store.dispatch('exhibitionItem/listExhibitionItems', {
        page,
        itemsPerPage,
        exhibitionId: this.exhibitionId,
      });
    },

    startDrag(event, exhibitionItem) {
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('id', exhibitionItem.id);
      event.dataTransfer.setData('type', 'exhibitionItem');
      event.dataTransfer.setData('exhibitionId', this.exhibitionId);
    },

    async deleteItem({ id, name }) {
      if (await this.$root.$confirm.open(
        i18n.t('common.delete'),
        i18n.t('exhibitionItems.deleteConfirm'),
        { color: 'red', itemName: name[this.language] },
      )) {
        await this.$store.dispatch('exhibitionItem/deleteExhibitionItem', { exhibitionId: this.exhibitionId, id });

        // If the removed item was the last one in the page we need to go to the previous page
        if (this.exhibitionItems.length - 1 <= 0 && this.options.page > 1) {
          this.options.page -= 1;
        }
        this.$store.dispatch('exhibitionItem/listExhibitionItems', {
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          exhibitionId: this.exhibitionId,
        });
      }
    },
  },
  created() {
    this.$store.dispatch('exhibitionItem/listExhibitionItems', { exhibitionId: this.exhibitionId });
  },
  mounted() {
    if (this.bus) {
      this.bus.$on('refresh', this.getDataFromApi);
    }
  },
  computed: {
    exhibitionItems() {
      return this.$store.state.exhibitionItem.exhibitionItems;
    },
    totalExhibitionItems() {
      return this.$store.state.exhibitionItem.totalExhibitionItems;
    },
    loading() {
      return this.$store.state.exhibitionItem.loading;
    },
    language() {
      return this.$i18n.locale;
    },
    headers() {
      return [
        ...(this.showDraggableColumn ? [
          {
            text: i18n.t('exhibitionItems.list.drag'),
            value: 'drag',
            sortable: false,
            width: '64px',
          },
        ] : []),
        {
          text: i18n.t('exhibitionItems.list.open'),
          value: 'open',
          sortable: false,
          width: '64px',
        },
        {
          text: i18n.t('exhibitionItems.list.name'),
          value: `name.${this.language}`,
          sortable: false,
        },
        {
          text: i18n.t('exhibitionItems.list.isHidden'),
          value: 'isHidden',
          sortable: false,
        },
        {
          text: i18n.t('exhibitionItems.list.createdAt'),
          value: 'createdAt',
          sortable: false,
        },
        {
          text: i18n.t('exhibitionItems.list.updatedAt'),
          value: 'updatedAt',
          sortable: false,
        },
        { text: i18n.t('exhibitionItems.list.actions'), value: 'actions', sortable: false },
      ];
    },
  },
};
</script>

<style scoped>

</style>
